import { render, staticRenderFns } from "./service-dialog.vue?vue&type=template&id=4d9f19b0&scoped=true"
import script from "./service-dialog.vue?vue&type=script&lang=ts"
export * from "./service-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9f19b0",
  null
  
)

export default component.exports